import Config from '@config';
import { initializeSSOIntegrationsApi } from '@gasbi/shared/common/features/ssoIntegrations';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const {
  ssoIntegrationsApi,
  useGetSSOSettingsQuery,
  useGetSSOConfigurationsQuery,
  useGetSSOConfigurationBySchemaQuery,
  useCreateSSOConfigurationMutation,
  useUpsetSSOConfigurationMutation,
  useUpsetPartialSSOConfigurationMutation,
  useToggleSSOConfigurationMutation,
} = initializeSSOIntegrationsApi({
  baseUrl: Config.VITE_API_URL + '/sso-integrations',
  baseQuery: axiosBaseQuery,
});
